//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            addForm: {
                name: "",
                value: '',
                type: '',
                description: '',
                sort: 10,
                sysDicFlag: 1,
                state: 0,
                remarks: '',
                parentId: 0,
                levelFlag: 1,
            },
            rules: {
                name: [
                    {required: true, message: '请输入字典名称'}
                ],
                value: [
                    {required: true, message: '请输入字典值'}
                ],
                type: [
                    {required: true, message: '请输入字典类型'}
                ]
            },
            parentMenuList: []
        };
    },
    inject: ['showLoading', 'hideLoading'],
    async created() {
        let activeItem = this.$store.state['dict'].activeItem;
        this.parentMenuList.push(activeItem);
        if (activeItem.id) {
            this.addForm.parentId = activeItem.id;
            this.addForm.levelFlag = 2;
        }
    },
    methods: {
        goList() {
            this.$emit('hideAdd', false);
        },

        //提交新增数据
        submitForm() {
            if (this.addForm.parentId === 0 && this.addForm.type === 1) {
                this.$notify({
                    title: '提示',
                    message: '按钮不能作为父级',
                    type: 'error',
                    duration: 2000,
                    position: "bottom-right"
                });
                return
            }
            this.$refs["addForm"].validate(async (valid) => {
                if (valid) {
                    this.showLoading();
                    let addRes = await this.$store.dispatch("dict/addDictInformation", this.addForm);
                    this.hideLoading();
                    let type = 'error';
                    if (addRes.code === 200) {
                        type ='success';
                        this.$parent.$parent.$refs.list.search();
                        this.goList();
                    }
                    this.$notify({
                        title: '提示',
                        message: addRes.msg,
                        type: type,
                        duration: 2000,
                        position: "bottom-right"
                    });
                }
            });
        },
        resetForm() {
            this.$refs["addForm"].resetFields();
        },
    }
}
